<nav id="mainSidebar" class="sidebar">
    <ul class="list-unstyled components" *ngIf="isAdminSection">
        <li>
            <a class="" routerLink="/app/admin/users" routerLinkActive="active">
                <i class="fa cfa cfa-user"></i>
                <span>Utilisateurs</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/admin/pro" routerLinkActive="active">
                <i class="fa cfa cfa-briefcase"></i>
                <span>Comptes pro</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/admin/ambassadors" routerLinkActive="active">
                <i class="fa cfa cfa-star"></i>
                <span>Ambassadeurs</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/admin/leads" routerLinkActive="active">
                <i class="fa cfa cfa-call"></i>
                <span>Leads</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app">
                <i class="fa cfa cfa-arrow-left"></i>
                <span>Retour sur l'app</span>
            </a>
        </li>
    </ul>

    <ul class="list-unstyled components" *ngIf="!isAdminSection">
        <li>
            <a class="" routerLink="/app/search" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <i class="fa cfa cfa-search"></i>
                <span>Recherche</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/city" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <i class="fa cfa cfa-home"></i>
                <span>Mes secteurs</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/tools/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}">
                <i class="fa cfa cfa-graph"></i>
                <span>Nos outils</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/favorites"
               [class.active]="router.url.startsWith('/app/favorites') && !router.url.startsWith('/app/favorites/leads')">
                <i class="fa cfa cfa-heart"></i>
                <span>Mes favoris</span>
            </a>
        </li>
        <li *ngIf="authenticationService.canPublishFavorite">
            <a class="" routerLink="/app/favorites/leads" routerLinkActive="active">
                <i class="fa cfa cfa-call"></i>
                <span>Mes leads</span>
            </a>
        </li>
        <li class="hide-mobile">
            <a class="" routerLink="/app/patrimoine" routerLinkActive="active">
                <i class="fa cfa cfa-buildings"></i>
                <span>Mon patrimoine <span class="badge-beta">BÊTA</span></span>
            </a>
        </li>
        <li *ngIf="showHistoric"
            [stepContent]="showHistoricStepContent"
            joyrideStep="showHistoricStep">
            <a class="hide-mobile" routerLink="/app/historic" routerLinkActive="active">
                <i class="fa cfa cfa-history"></i>
                <span>Mon historique</span>
            </a>
        </li>
        <li *ngIf="showApiDashboard">
            <a class="" routerLink="/app/user/dashboard-api" routerLinkActive="active">
                <i class="fa cfa cfa-graph"></i>
                <span>Dashboard API</span>
            </a>
        </li>
        <li>
            <a class="" routerLink="/app/appli-mobile" routerLinkActive="active">
                <i class="fa cfa cfa-mobile"></i>
                <span>Appli Mobile</span>
            </a>
        </li>
        <li class="minimize isMinimizable">
            <a class="mb-2 cta_min">
                <i class="fa cfa cfa-findeparcours"></i>
                <span>Aller plus loin
                    <img class="down" src="assets/icons/down.svg" />
                </span>
            </a>
            <ul>
                <li><a href="https://tally.so/r/mRPzQ4?utm_source=app" target="_blank">Investissement clé en main</a></li>
<!--                <li><a href="">Formation immobilière</a></li>-->
                <li><a href="https://www.thomas-cornu.fr/accompagnement-immobilier" target="_blank">Coaching immobilier</a></li>
                <li><a href="https://chat.whatsapp.com/IUIMJGa1BIsInSSYpQ0Cxr" target="_blank">Groupe privé</a></li>
                <li><a routerLink="/app/partners" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" href="">Partenaires</a></li>
            </ul>
        </li>
<!--        <li>-->
<!--            <a class="offre-bf hide-mobile" href="https://g07t4ye8.sibpages.com/">-->
<!--                <i class="fa cfa cfa-clock-o"></i>-->
<!--                <span>Offre black Friday</span>-->
<!--            </a>-->
<!--        </li>-->
    </ul>

    <a class="text-center collapseBtn hide-mobile">
        <i class="fa fa-angle-left"></i>
        <i class="fa fa-angle-right"></i>
    </a>
</nav>

<!-- Onboarding -->
<ng-template #showHistoricStepContent>
    <div class="user_onboarding_content">
        <h2>Mon historique</h2>
        <p>
            Vous avez trouvé une super annonce, mais vous ne l’avez pas enregistrée en favoris ?<br/>
            <br/>
            Pas de panique ! Retrouvez ici l’historique des dernières annonces ouvertes.
        </p>
    </div>
</ng-template>
